/* globals window, document, jQuery, App, configurations */
/**
 * Geo IP checked constants returned from backend:
 * 0 & 1 can't recognize
 * 2 correct country
 * 3 other country (fuck them all)
 * 4 other country
 */
(function ($, App, doc, win, con) {

    var CONST = {
            CORRECT_COUNTRY: 2,
            INCORRECT_COUNTRY: 4,
            NON_EXIST_PROJECT: 3,
            SPAIN_COUNTRY_ID: 6
        },
        STATUS = {
            MESSAGE_FLAG: 'geoIP',
            USER_CHANGE_COUNTRY: 'accepted',
            USER_KEEP_COUNTRY: 'declined'
        },
        URL = {
            GET_LOCATION: con.routes.front_geo_Location_by_ip,
            GET_LOCATION_LAYER: '/front/front/load_project_suggest_layer'
        },
        modal = new App.Modal({
            isSmall: true
        }),

        geoLocationManager = {
            checkUserResponse: function alreadyChecked(response) {
                return window.App.Cookie.get(STATUS.MESSAGE_FLAG) === response;
            },

            isChecked: function isChecked() {
                return window.App.Cookie.isset(STATUS.MESSAGE_FLAG) && window.App.Cookie.get(STATUS.MESSAGE_FLAG) === STATUS.USER_KEEP_COUNTRY;
            },

            saveResult: function (response) {
                window.App.Cookie.set(STATUS.MESSAGE_FLAG, response);
            },

            /**
             * Loads the user's geoIP.
             * If the province is found, this method change the select from the
             * the Home_Search with the given Area2.
             * If the project with the similar category is found, shows the layer
             * to the user which suggest the possibility to change the project.
             */
            checkGeoIp: function checkGeoIp() {
                var self = this;

                if (self.isChecked()) {
                    return;
                }

                self.checkGeoIpRequest().then(function (data) {
                    self.setGeoIpLayer(data);
                });
            },

            checkGeoIpRequest: function () {
                return $.ajax({
                    url: URL.GET_LOCATION,
                    type: 'GET'
                });
            },

            setGeoIpLayer: function (data) {
                this.saveResult(data.message);
                geoIpLayer.analyzeIp(data);
            },

            isAllowedToMakeRequests: function (geoLocalizationResponse) {
                var isSpain = parseInt(window.configurations.project.projectCountryId) === CONST.SPAIN_COUNTRY_ID;

                return isSpain ? parseInt(geoLocalizationResponse) === CONST.CORRECT_COUNTRY
                    : parseInt(geoLocalizationResponse) === CONST.CORRECT_COUNTRY ||
                    parseInt(geoLocalizationResponse) === CONST.NON_EXIST_PROJECT;

            }
        },

        geoIpLayer = {
            /**
             * Analyze if is correct ip or not and show advert
             * @param {object} data - ajax response with/out countryMessageAlert property
             * The advert can be shown as alert or as modal.
             * Just send property countryMessageAlert to true if wants to be an alert
             */
            analyzeIp: function analyzeIp(data) {
                var correctCountry = parseInt(data.message) === CONST.CORRECT_COUNTRY,
                    nonExistCountry = parseInt(data.message) === CONST.NON_EXIST_PROJECT,
                    incorrectCountry = parseInt(data.message) === CONST.INCORRECT_COUNTRY,
                    incorrectCountryAcceptedByUser = (
                        geoLocationManager.checkUserResponse(STATUS.USER_KEEP_COUNTRY) ||
                        geoLocationManager.checkUserResponse(CONST.INCORRECT_COUNTRY.toString()) ||
                        geoLocationManager.checkUserResponse(CONST.NON_EXIST_PROJECT.toString())
                    );

                if (!data.error) {
                    if (correctCountry) {
                        this.selectAreaInSelect(data.result.ae2_id);
                    }
                    if ((nonExistCountry || incorrectCountry) && incorrectCountryAcceptedByUser) {
                        this.requestLayer(data.result.pro_id);
                    }
                }
            },

            selectAreaInSelect: function selectArea2(area) {
                var homeSelect = '.jq_option_ae2_' + area,
                    isVerticales = $('#home_search').length;

                if (isVerticales > 0) {
                    $(homeSelect).attr('selected', true);
                }
            },

            requestLayer: function requestLayer(projectId) {
                var self = this;
                modal.showLoading();

                $.ajax({
                    url: URL.GET_LOCATION_LAYER + '?pro_sugg=' + projectId,
                    type: 'GET',
                    success: function (response) {
                        self.showLayer(response);
                    }
                });
            },

            showLayer: function showLayer(response) {
                var self = this;

                modal.insert(response, false).then(() => self.layerEventManager($('body')));
            },

            closeLayer: function closeLayer(element) {
                element.remove();
            },

            layerEventManager: function layerEventManager($body) {
                var $suggestedLnk = $body.find('.js_project_suggest_ref'),
                    $keepInProject = $body.find('.js_keep_in_project'),
                    $layer = $body.find('#js_country_sel'),
                    self = this,
                    days = 30;

                // Trackers the layer visited.
                self.trackAction('intl_layer');

                // Closes the project country layer.
                $keepInProject.on('click', function (e) {
                    e.preventDefault();

                    self.trackAction('declined');
                    self.closeLayer($layer);
                    modal.remove();

                    window.App.Cookie.set(STATUS.MESSAGE_FLAG, STATUS.USER_KEEP_COUNTRY, days);
                });

                // Goes to suggested project.
                $suggestedLnk.on('click', function (e) {
                    self.trackAction('accepted');
                    self.closeLayer($layer);

                    window.App.Cookie.set(STATUS.MESSAGE_FLAG, STATUS.USER_CHANGE_COUNTRY, days);
                });
            },

            trackAction: function trackAction(action) {
                var $country = $('#js_project_suggest_track').attr('name');
                window.gaqTrackEvent('send', 'event', 'GeoIP', action, $country, 1, {'nonInteraction': true});
            }
        };

    App = App || {};
    App.geoLocationManager = geoLocationManager;

}(jQuery, App, document, window, configurations));
